import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { util } from '../../../util'
import { Icon } from '../index'

const Accordion = ({
    children,
    width,
    forceLocKed,
    forceClose,
    onAccordionClose,
    defaultExpanded = false,
    disabled = false,
    className,
    step,
}) => {
    const [showDetails, setShowDetails] = useState(defaultExpanded)
    useEffect(() => {
        if (forceLocKed) {
            setShowDetails(false)
        }
        if (forceClose) {
            toggleShowDetails()
            !!onAccordionClose && onAccordionClose()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [forceLocKed, forceClose])

    const toggleShowDetails = () => {
        if (!disabled) {
            setShowDetails(!showDetails)
        }
    }

    const accordionClass = util.joinClasses('accordion', width, disabled && 'disabled', className)

    return (
        <div data-testid={'accordion'} className={accordionClass}>
            {React.Children.toArray(children).map(child =>
                React.cloneElement(child, {
                    toggleAccordionDetails: toggleShowDetails,
                    showDetails: showDetails,
                    disabled: disabled,
                    step,
                })
            )}
        </div>
    )
}

const AccordionSummary = ({
    children,
    defaultLayout = true,
    toggleAccordionDetails,
    showDetails,
    disabled,
    className,
}) => {
    return (
        <div
            data-testid={'accordion-summary'}
            className={util.joinClasses('accordion-summary', disabled && 'disabled', className)}
        >
            {defaultLayout ? (
                <div className={'accordion-summary__container'} onClick={toggleAccordionDetails}>
                    <div data-testid={'accordion-summary__container--children'}>{children}</div>
                    <Icon
                        size={'sm'}
                        className={'accordion-summary__container--expand-icon'}
                        renderIcon={showDetails ? util.ExpandLessIcon : util.ExpandMoreIcon}
                    />
                </div>
            ) : (
                children &&
                React.cloneElement(children, {
                    onClickHandler: toggleAccordionDetails,
                    open: showDetails,
                })
            )}
        </div>
    )
}

const AccordionDetails = ({ children, showDetails, className, toggleAccordionDetails }) => {
    return (
        <div className={util.joinClasses('accordion-details', !showDetails && 'hide', className)}>
            {children &&
                React.cloneElement(children, {
                    isSectionOpened: showDetails,
                    closeAccordion: toggleAccordionDetails,
                })}
        </div>
    )
}

const AccordionActions = ({ children, showDetails, className, ...rest }) => {
    return (
        <div
            className={util.joinClasses('accordion-actions', !showDetails && 'hide', className)}
            {...rest}
        >
            {children}
        </div>
    )
}

Accordion.Summary = AccordionSummary
Accordion.Details = AccordionDetails
Accordion.Actions = AccordionActions

Accordion.propTypes = {
    children: PropTypes.node,
    width: PropTypes.oneOf(['md', 'rg', 'sm', 'lg']),
    defaultExpanded: PropTypes.bool,
    disabled: PropTypes.bool,
    className: PropTypes.string,
}

AccordionSummary.propTypes = {
    children: PropTypes.node,
    defaultLayout: PropTypes.bool,
    toggleAccordionDetails: PropTypes.func,
    showDetails: PropTypes.bool,
    disabled: PropTypes.bool,
    className: PropTypes.string,
}

AccordionDetails.propTypes = {
    children: PropTypes.node,
    showDetails: PropTypes.bool,
    className: PropTypes.string,
}

AccordionActions.propTypes = {
    children: PropTypes.node,
    showDetails: PropTypes.bool,
    className: PropTypes.string,
}

export default Accordion
